import React from 'react'
import Menu from './Menu'
import Curriculum from './Curriculum'
import Paper from '@mui/material/Paper'

const ContainerMenu = () => (
  <aside>
    <Paper square elevation={0} className='h-full'>
      <div className='relative h-full'>
        <Menu />
        <Curriculum />
      </div>
    </Paper>
  </aside>
)
export default ContainerMenu